import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // The SubscribePage handles the session_id verification
  // This page is just a fallback display
  
  return (
    <div className="min-h-screen bg-[#F7F5F2] flex items-center justify-center p-4">
      <Card className="max-w-md w-full rounded-2xl border-stone-200">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-[#6B8E7B]/10 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-8 w-8 text-[#6B8E7B]" />
          </div>
          <h1 className="text-2xl font-bold text-stone-800 mb-2 font-['Outfit']">Payment Successful!</h1>
          <p className="text-stone-600 mb-6">
            Welcome to Premium! You now have access to anonymous sharing.
          </p>
          <Button
            onClick={() => navigate('/anonymous')}
            className="btn-premium"
            data-testid="go-anonymous-button"
          >
            Start Sharing Anonymously
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccessPage;
